import { PulseBaseProvider } from '../../../../base-classes';
import { IPulseRequestConfiguration } from "../../../types/PulseInterfaces";
import {
	GetHurricaneOutlookSummaryActionParameters
} from "../../../actions/Hurricane/Outlook/Summary/hurricaneOutlookSummaryAction";

const _currentUri = '/api/hur/outlook/v2/summary';
const _currentHurricaneOutlookSummaryCacheKey = 'currentHurricaneOutlookSummary';

export class HurricaneOutlookSummaryProvider extends PulseBaseProvider {
	constructor({ baseUrl, authId, secret, options, logger }: IPulseRequestConfiguration) {
		super(baseUrl, authId, secret, options, logger);
		this.storage.sync[_currentHurricaneOutlookSummaryCacheKey] = this.hurricaneOutlookBulletinSyncer.bind(this);
	}

	async hurricaneOutlookBulletinSyncer(params) {
		const { id, syncParams, resolve, reject } = params;

		const queryParams = {
			...syncParams.stdParameters,
			includeForecast2d: syncParams.includeForecast2d,
			includeForecast7d: syncParams.includeForecast7d
		};

		return await super.syncData(syncParams.key, id, queryParams, _currentUri, resolve, reject, null, syncParams.pulseApi);
	}

	/**
	 * Fetches the observations from storage if they exist and are still valid or fetches new outlook summary(ies) if needed.
	 * @param apiParameters
	 * -- All of the parameters for the Hurricane Outlook API to be aware of when requesting outlook bulletins
	 * -- API Docs are available here -- http://twoutlookapi-hur.weatherbugsc.com/swagger/index.html
	 */
	async getHurricaneOutlookSummary(apiParameters: GetHurricaneOutlookSummaryActionParameters) {
		const syncParams = {
			includeForecast2d: apiParameters.includeForecast2d,
			includeForecast7d: apiParameters.includeForecast7d
		};
		const id = JSON.stringify(syncParams);

		if (apiParameters.forceRefreshOfCachedData) {
			super.removeFromStorage(_currentHurricaneOutlookSummaryCacheKey, id);
		}
		return await super.loadFromStorage(_currentHurricaneOutlookSummaryCacheKey, id, syncParams);
	}
}
